import { isNumber } from 'lodash';

export const selectValueSeparator = '---';

export const getValueAndQueryWithSelectSeparator = (fullValue?: number | string): string[] => {
  if (fullValue === undefined) return ['', '', ''];
  if (isNumber(fullValue)) return [fullValue.toString(), fullValue.toString(), fullValue.toString()];
  const indexOfSeparator = fullValue.indexOf(selectValueSeparator);
  if (indexOfSeparator < 0) return [fullValue, fullValue, fullValue];
  return [
    fullValue.substr(indexOfSeparator + selectValueSeparator.length),
    fullValue.substring(0, indexOfSeparator),
    fullValue,
  ];
};
